export default __webpack_public_path__ + "static/N0313-4aacef5d2f6345e2ba17f7dc61b78e01.png";